import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setTokens, clearTokens, getToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            const t = getToken();
            if (!t) {
                setUser(false);
                setLoading(false);
                return;
            }
            try {
                const { data } = await api.get("/auth/me");
                setUser(data);
            } catch {
                clearTokens();
                setUser(false);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        setTokens(data.access_token, data.refresh_token);
        setUser(data.user);
        return data.user;
    };

    const register = async (name, email, password) => {
        const { data } = await api.post("/auth/register", { name, email, password });
        setTokens(data.access_token, data.refresh_token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        clearTokens();
        setUser(false);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
